import React from 'react';

const FileUploader = ({ 
  label = "Upload File", 
  text, 
  onChange, 
  multiple = false, 
  progress = 0, 
  icon = "fi-rr-cloud-upload",
  className = ""
}) => {
  return (
    <div className={`dash-form-group ${className}`}>
      <label>{label}</label>
      <div className="dash-form-file py-4">
        <i className={`fi ${icon}`}></i>
        {text}
        <input type="file" onChange={onChange} multiple={multiple} />
        {progress > 0 && (
          <div className="form-file-progress" style={{ width: `${progress}%` }}></div>
        )}
      </div>
    </div>
  );
};

export default FileUploader; 